export default "__VITE_ASSET__CqOmqR$E__"